import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Card from 'component/GamePanel/Card'
// import CardsLeft from './CardsLeft';
import styles from './style.module.scss';
import Immutable from "immutable";

// import { connect } from 'react-redux';
// import { newGame, addClicked, replaceCard } from '../../actions/cards';

export default class GamePanel extends React.Component {
    static propTypes = {
        cardDeck: ImmutablePropTypes.list.isRequired,
        cardsOut: ImmutablePropTypes.list,
        cardsClickedOn: ImmutablePropTypes.list,
        cardsUsed: ImmutablePropTypes.list,

        addClicked: PropTypes.func.isRequired,
        shuffle: PropTypes.func.isRequired,

        // replaceCard: PropTypes.func.isRequired,
    };

    addClicked = (number, color, shape, shading, index) => {
        // console.log('adding clicked', number, color, shape, shading, index);
        this.props.addClicked(number, color, shape, shading, index);
    }



    render() {
        const card_rows = []
        const cardsOutList = this.props.cardsOut;
        let cardsClickedOnList = [];
        console.log("ahhh")

        // getting the index(es) of the cards that have been clicked on
        if (this.props.cardsClickedOn.size > 0) {
            for (let i = 0; i < this.props.cardsClickedOn.size; i++) {
                cardsClickedOnList.push(this.props.cardsClickedOn.get(i).index);
            }
        }
        let x = 0;
        for (let i = 0; i < 3; i++) {
            card_rows.push([]);
            for (let j = 0; j < 4; j++) {
                let cardInfoMap = cardsOutList.get(x, Immutable.Map());
                let isThisClicked = cardsClickedOnList.includes(x);

                card_rows[i][j] = <Card
                    key={`card-${i}-${j}`}
                    className={styles['box']}
                    number={cardInfoMap.get('number')}
                    color={cardInfoMap.get('color')}
                    shape={cardInfoMap.get('shape')}
                    shading={cardInfoMap.get('shading')}
                    index={cardInfoMap.get('index')}
                    isClicked={isThisClicked}
                    onClick={this.addClicked}
                />;
                x = x + 1;
            }
        }

        return (
            <div className={styles.border_of_game}>
                {card_rows.map((card_row, i) => (
                    <ul key={`card-row-${i}`} className={styles.container_card_row}>
                        {card_row}
                    </ul>
                ))
                }
                <div className={styles.last_row}>
                    <h2>Cards Left: {this.props.cardDeck.size}</h2>
                    <button
                        className={styles.shuffle}
                        onClick={this.props.shuffle}>Shuffle</button>
                </div>


            </div >)
    }
}